export default "/fonts/Ubuntu-Light.woff2?5f2d12d49f175c263326ffb0f5754132";